"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockStatePriceProvider__factory = void 0;
var ethers_1 = require("ethers");
var MockStatePriceProvider__factory = /** @class */ (function (_super) {
    __extends(MockStatePriceProvider__factory, _super);
    function MockStatePriceProvider__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockStatePriceProvider__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockStatePriceProvider__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockStatePriceProvider__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockStatePriceProvider__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockStatePriceProvider__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return MockStatePriceProvider__factory;
}(ethers_1.ContractFactory));
exports.MockStatePriceProvider__factory = MockStatePriceProvider__factory;
var _abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "symbol",
                type: "bytes32",
            },
        ],
        name: "getPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_price",
                type: "uint256",
            },
        ],
        name: "setPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405261030960005534801561001657600080fd5b506101ba806100266000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806331d98b3f1461003b57806391b7f5ed1461006b575b600080fd5b610055600480360381019061005091906100c6565b610087565b6040516100629190610127565b60405180910390f35b610085600480360381019061008091906100ef565b610092565b005b600080549050919050565b8060008190555050565b6000813590506100ab81610156565b92915050565b6000813590506100c08161016d565b92915050565b6000602082840312156100d857600080fd5b60006100e68482850161009c565b91505092915050565b60006020828403121561010157600080fd5b600061010f848285016100b1565b91505092915050565b6101218161014c565b82525050565b600060208201905061013c6000830184610118565b92915050565b6000819050919050565b6000819050919050565b61015f81610142565b811461016a57600080fd5b50565b6101768161014c565b811461018157600080fd5b5056fea264697066735822122049a15e0b3dbb95df66aaa32aa96771667aff095ecfe46c2cae0d44d185ea05a664736f6c63430008040033";
//# sourceMappingURL=MockStatePriceProvider__factory.js.map